import API from "../API";
import { AxiosResponse } from "axios";

export const listTerms = async (): Promise<AxiosResponse> =>
  API.get(`/term/last`);

type TermCreatePayload = {
  title: string;
  content: string;
};

export const createTerm = async (
  payload: TermCreatePayload
): Promise<AxiosResponse> => await API.post("/term/create", payload);
